// Timing constants for FileDropzone components

// Validation error display timing
export const VALIDATION_ERROR_DISPLAY_TIME = 2500; //ms
export const ERROR_FADE_OUT_TIME = 250; //ms

// Marquee animation timing
export const MARQUEE_BASE_DURATION = 1.0; //s
export const MARQUEE_MIN_DURATION = 2.5; //s

// Progress display
export const PROGRESS_MIN_VISIBLE = 3; // Minimum 3% visibility

// Auto-scroll timing
export const AUTO_SCROLL_DELAY = 100;  //ms
// Drag & Drop visual feedback timing
export const DRAG_STATE_FEEDBACK_TIME = 2500; //ms
